import React from "react";
import {
  Card,
  Modal,
  Tag,
  Typography,
  Alert,
  Button,
  Space,
  Select,
} from "antd";
import { useState } from "react";
import {
  CheckOutlined,
  DingdingOutlined,
  FieldTimeOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useEffect } from "react";
import "./groupAssign.css";
import { useSelector } from "react-redux";

const AssignGroupModal = ({
  visible,
  setVisible,
  selectedRows,
  handleAssignGroup,
}) => {
  const [trips, setTrips] = useState([]);
  const [focused, setFocused] = useState(false);
  const [data, setData] = useState({
    groupId: null,
  });
  const [remainingSlots, setRemainingSlots] = useState([]);

  const staticSlots = useSelector((state) => state.team.slots);
  const allGroups = useSelector((state) => state?.groups?.all);

  useEffect(() => {
    if (selectedRows) {
      setData({
        groupId: selectedRows?.[0]?.customProperties?.groupId,
      });
    }
  }, [selectedRows]);

  useEffect(() => {
    const groupsDetails = allGroups.find(
      (option) => option.groupId === data.groupId
    );
    setTrips(groupsDetails ? groupsDetails.trips : []);

    let allStaticSlots = JSON.parse(JSON.stringify(staticSlots));
    if (groupsDetails && groupsDetails.trips) {
      groupsDetails.trips.forEach((trip) => {
        trip.trip_slots.forEach((element) => {
          allStaticSlots = allStaticSlots.filter(
            (slot) =>
              slot.startTime !== element.startTime ||
              slot.endTime !== element.endTime
          );
        });
      });
    }
    setRemainingSlots(allStaticSlots);
  }, [data, staticSlots, allGroups]);

  const handleCancel = () => {
    setVisible(false);
  };

  const handleSubmit = () => {
    handleAssignGroup(data);
  };

  return (
    <div>
      <Modal
        title="Assign a Group"
        open={visible}
        onCancel={handleCancel}
        width="30%"
        style={{
          top: 0,
          minWidth: "20rem",
          height: "94vh",
          right: "-34.7%",
          position: "relative",
        }}
        bodyStyle={{
          height: "83vh",
          overflowY: "auto",
          backgroundColor: "#E7E9EE",
          fontSize: "12px",
        }}
        footer={[
          <div style={{ textAlign: "right" }}>
            <Button
              onClick={handleSubmit}
              style={{
                backgroundColor: "rgb(0, 114, 245)",
                color: "white",
                marginRight: "5px",
                borderRadius: "10px",
              }}
            >
              <CheckOutlined /> Assign Group
            </Button>
          </div>,
        ]}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ fontSize: "20px" }}>
            <TeamOutlined />
          </div>

          <div
            style={{
              marginLeft: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography.Text>Select Team</Typography.Text>
            <Tag
              style={{
                borderLeft: "3px solid green",
                backgroundColor: "#F3F4F6",
              }}
            >
              {selectedRows?.[0]?.id}
            </Tag>
          </div>
        </div>
        <div className={`custom-select ${focused ? "focused" : ""}`}>
          <label>Select Group</label>
          <Select
            value={data?.groupId}
            size="default"
            onChange={(newValue) =>
              setData((preState) => {
                return { ...preState, groupId: newValue };
              })
            }
            style={{
              width: "100%",
            }}
            placeholder="Select Group"
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            tagRender={(props) => {
              const { label, closable, onClose } = props;
              return (
                <Tag
                  closable={closable}
                  onClose={onClose}
                  style={{ marginRight: 3 }}
                >
                  {label}
                </Tag>
              );
            }}
          >
            {allGroups?.map((group) => (
              <Select.Option key={group.groupId} value={group.groupId}>
                {group.groupName}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Card
          key={"slot_card"}
          style={{
            marginTop: "5px",
            backgroundColor: "#F3F4F6",
          }}
        >
          <Typography.Text>Customer Slots (Remaining)</Typography.Text>

          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {remainingSlots?.map((remainingSlot, index) => (
              <Tag
                key={index}
                style={{
                  backgroundColor: "#E7E9EE",
                  marginBottom: "2px",
                  marginRight: "8px",
                }}
              >
                {remainingSlot?.startTime} - {remainingSlot?.endTime}
              </Tag>
            ))}
            <Alert
              message="Orders associated with these customer slots can be allocated to any trips."
              type="warning"
              showIcon
              style={{
                marginBottom: "5px",
                marginTop: "5px",
                fontSize: "12px",
              }}
            />
          </div>
        </Card>
        {trips.map((trip, index) => (
          <Card
            key={index}
            style={{
              backgroundColor: "#F3F4F6",
              marginBottom: "5px",
              marginTop: "8px",
              minWidth: "250px",
              fontSize: "10px",
              position: "relative",
            }}
          >
            <Space
              direction="vertical"
              style={{ width: "100%", marginTop: "10px" }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ fontSize: "13px" }}>Trip {index + 1}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ fontSize: "20px" }}>
                  <DingdingOutlined />
                </div>

                <div
                  style={{
                    marginLeft: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography.Text>Trip Id</Typography.Text>
                  <Typography.Text>{trip?.trip_id}</Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ fontSize: "20px" }}>
                  <FieldTimeOutlined />
                </div>

                <div
                  style={{
                    marginLeft: "4px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography.Text>Slots</Typography.Text>
                  <div>
                    {trip?.trip_slots?.map((slot, index) => (
                      <Tag
                        key={index}
                        className="slot"
                        style={{ backgroundColor: "#E7E9EE" }}
                      >{`${slot?.startTime} - ${slot?.endTime}`}</Tag>
                    ))}
                  </div>
                </div>
              </div>
            </Space>
          </Card>
        ))}
      </Modal>
    </div>
  );
};

export default AssignGroupModal;
